import axios from 'axios';

import { IRiServiceType } from '@/shared/model/ri-service-type.model';

const baseApiUrl = 'api/ri-service-types';

export default class RiServiceTypeService {
  public find(id: number): Promise<IRiServiceType> {
    return new Promise<IRiServiceType>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveVisible(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/visible`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export { IRiServiceType };
